<template lang="pug">
span.secret.wrapper.input-group
  Input(:type="inputType" v-model="value")
  .input-group-btn
    button.btn.btn-default(type="button" @click="revealed = !revealed")
      i.fa(:class="{ 'fa-eye': revealed, 'fa-eye-slash': !revealed }")
    button.btn.btn-default(type="button" @click="copyToClipboard()")
      i.fa.fa-copy

</template>

<script>
  import store from '@/store'
  import { copyTextToClipboard } from '@/utils/clipboard'

  import Input from './input.vue'

  export default {
    components: {
      Input
    },

    props: {
      value: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        revealed: false
      }
    },

    computed: {
      inputType() {
        return this.revealed ? 'text' : 'password'
      }
    },

    methods: {
      async copyToClipboard() {
        if(copyTextToClipboard(this.value)) {
          store.dispatch('messages/addNotice', 'Copied to clipboard')
        } else {
          store.dispatch('messages/addAlert', 'Unable to copy to clipboard')
        }
      }
    }
  }
</script>
